export default "__VITE_ASSET__CEgrr7Pl__"